const actions = {
    FETCH_USER_MONTHLY_ATTENDANCES: 'FETCH_USER_MONTHLY_ATTENDANCES',
    FETCH_MONTH_DECLARATION_DATE: 'FETCH_MONTH_DECLARATION_DATE',
    RESET_MONTH_DECLARATION_DATE: 'RESET_MONTH_DECLARATION_DATE',

    fetchUserMonthlyAttendancesAction: (data) => {
        return {
            type: actions.FETCH_USER_MONTHLY_ATTENDANCES,
            data: data
        };
    },
    fetchMonthDeclarationDateAction: (data) => {
        return {
            type: actions.FETCH_MONTH_DECLARATION_DATE,
            data: data
        };
    },
    resetUserMonthlyAttendanceFormAction: (data) => {
        return {
            type: actions.RESET_MONTH_DECLARATION_DATE,
            data: data
        };
    },
};

export default actions;
